import React, { useEffect, useState } from 'react';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  theme?: 'light' | 'dark' | 'danger';
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 27,
  initialSeconds = 35,
  className = '',
  theme = 'danger'
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const themes = {
    light: 'bg-white text-slate-900 border-slate-200',
    dark: 'bg-slate-900 text-white border-slate-700',
    danger: 'bg-red-50 text-red-600 border-red-200'
  };
  return <div className={`inline-flex items-center gap-2 font-mono font-bold text-lg md:text-2xl px-4 py-2 rounded-lg border ${themes[theme]} ${className}`} data-id="element-345">
      <div className="flex flex-col items-center" data-id="element-346">
        <span data-id="element-347">{formatNumber(timeLeft.hours)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-348">
          hs
        </span>
      </div>
      <span className="opacity-50 pb-4" data-id="element-349">:</span>
      <div className="flex flex-col items-center" data-id="element-350">
        <span data-id="element-351">{formatNumber(timeLeft.minutes)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-352">
          min
        </span>
      </div>
      <span className="opacity-50 pb-4" data-id="element-353">:</span>
      <div className="flex flex-col items-center" data-id="element-354">
        <span data-id="element-355">{formatNumber(timeLeft.seconds)}</span>
        <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-356">
          seg
        </span>
      </div>
    </div>;
}